import CheckboxForm from "../CheckboxForm"
import { careerProfileLabels } from "../../Types/careerProfileLabels"
import RadioButtonField from "../../Utils/RadioButtonField"
import TextField from "../../Utils/TextField"
const Benefits = ({ formik }) => {
  return (
    <>
      <h4
        style={{
          marginBottom: "2rem",
          fontSize: "14px",
          color: "#383838",
          fontWeight: "400",
          lineHeight: "19px",
        }}
      >
        Remember, that increases in pay/work hours may affect your benefits. And
        if you quit working that can also affect your entitlements. If you
        experience a change in wages, contact a benefits planner to learn more.
      </h4>
      <CheckboxForm
        label={careerProfileLabels.benefits.benefits_received.label}
        value={formik.values.benefits_received}
        setValue={formik.setFieldValue}
        valueName={careerProfileLabels.benefits.benefits_received.value}
      />
      {formik.values.benefits_received.other && (
        <TextField
          label={careerProfileLabels.benefits.benefits_received_other.label}
          value={formik.values.benefits_received_other}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.benefits.benefits_received_other.value}
          size={30}
        />
      )}
      <div style={{ marginTop: "20px" }}>
        <RadioButtonField
          label={careerProfileLabels.benefits.benefits_1.label}
          value={formik.values.benefits_1}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.benefits.benefits_1.value}
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <RadioButtonField
          label={careerProfileLabels.benefits.benefits_2.label}
          value={formik.values.benefits_2}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.benefits.benefits_2.value}
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <RadioButtonField
          label={careerProfileLabels.benefits.benefits_3.label}
          value={formik.values.benefits_3}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.benefits.benefits_3.value}
        />
      </div>
    </>
  )
}
export default Benefits
